import React, { useState } from 'react';
import { useToggle } from 'react-use';
import classNames from 'classnames';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { api } from '~/api';
import { Button, Modal } from 'Components/nui';
import { FormattedMessage, useIntl } from 'react-intl';
import ActionList from 'Components/ActionList';
import { useInvalidateMarketOrders } from '~/pages/Market/hooks/useMarketOrders';

interface OwnerButtonsProps {
  order: any;
}

export default ({ order }: OwnerButtonsProps) => {
  const { formatMessage } = useIntl();
  const history = useHistory();
  const { pathname } = useLocation();

  const invalidateMarketOrders = useInvalidateMarketOrders();

  const [deleting, setDeleting] = useState(false);
  const [on, toggle] = useToggle(false);

  const deleteOrder = async () => {
    setDeleting(true);
    await api.getData(
      {
        type: 'orders',
        id: order.id,
      },
      null,
      { method: 'delete' }
    );

    toast.success(
      formatMessage({
        id: 'order-was-cancelled',
        defaultMessage: 'The order was cancelled',
      })
    );

    invalidateMarketOrders();
    history.replace(pathname);
    toggle(false);
  };

  return (
    <>
      <ActionList.Item>
        <Link
          to={`/orders/${order.pid}/edit`}
          className={classNames('button', order.type, 'small')}
        >
          <FormattedMessage
            id="marketrow-button-edit"
            defaultMessage="Edit"
            values={{ orderType: order.type }}
          />
        </Link>
      </ActionList.Item>
      <ActionList.Item>
        <Button type="simple" size="small" onClick={toggle}>
          <FormattedMessage
            id="marketrow-counters-button-delete"
            description="button for counters 'Delete' in Marketrow"
            defaultMessage="Delete"
          />
        </Button>
      </ActionList.Item>

      {on && (
        <Modal size="small" close={toggle}>
          <h2>
            <FormattedMessage
              id="marketrow-deletemodal-header"
              description="Header for delete modal in Marketrow"
              defaultMessage="Warning"
            />
          </h2>
          <p>
            <FormattedMessage
              id="marketrow-deletemodal-helptext"
              description="helptext for delete modal in Marketrow"
              defaultMessage="Are you sure you want to delete the order? You can't undo this operation."
            />
          </p>

          <hr />
          <div className="button-set">
            <Button type="primary" onClick={deleteOrder} loading={deleting}>
              <FormattedMessage
                id="vieworder-delete-order"
                defaultMessage="Delete order"
              />
            </Button>
            <Button type="simple" onClick={toggle}>
              <FormattedMessage
                id="marketrow-deletemodal-button-no"
                description="button for counters 'No, go back!' in Marketrow"
                defaultMessage="Go back"
              />
            </Button>
          </div>
        </Modal>
      )}
    </>
  );
};
